<script lang="ts" setup>
import { computed } from 'vue';
import type { CSSProperties } from 'vue';
import { useI18n } from 'vue-i18n';
import type { ProjectBannerResponse } from '@/api';

const props = defineProps<{
  isPaid: boolean;
  isSold: boolean;
  isNew: boolean;
  banners: ProjectBannerResponse[];
  horizontal?: boolean;
}>();

const { t } = useI18n();

interface ProjectBadgeItem {
  key: string | number;
  label: string;
  className?: string;
  style?: CSSProperties;
}

// Les bannières choisies dans l'admin passent avant « Nouvelle inscription » mais jamais avant « Vendu ».
const badges = computed<ProjectBadgeItem[]>(() => {
  if (props.isSold) return [{ key: 'sold', label: t('components.project-badge.sold'), className: 'bg-red-700 text-white' }];

  const bannerBadges = props.banners.map((banner) => ({
    key: banner.id,
    label: banner.name,
    style: {
      backgroundColor: banner.backgroundColor,
      color: banner.foregroundColor,
      border: banner.borderColor ? `2px solid ${banner.borderColor}` : undefined,
    },
  }));
  if (props.isPaid && bannerBadges.length > 0) return bannerBadges;

  if (props.isPaid && props.isNew) return [{ key: 'new', label: t('components.project-badge.new'), className: 'bg-ph-green-600 text-white' }];

  return [];
});
</script>

<template>
  <div v-if="badges.length > 0" :class="horizontal ? 'flex-row flex-wrap' : 'flex-col'" class="flex items-start gap-1.5">
    <span v-for="badge in badges" :key="badge.key" :class="badge.className" :style="badge.style" class="inline-block rounded-md px-2.5 py-0.5 text-xs font-bold shadow-md">{{ badge.label }}</span>
  </div>
</template>

<style lang="css" scoped></style>
